import {KeyboardShortcut} from '@wandb/weave/common/components/elements/KeyboardShortcut';
import {isMac} from '@wandb/weave/common/util/browser';
import {useBooleanState} from '@wandb/weave/common/util/hooks';
import {IconSearch} from '@wandb/weave/components/Icon';
import {TooltipDeprecated} from '@wandb/weave/components/TooltipDeprecated';
import React, {type FC, useContext} from 'react';
import styled from 'styled-components';

import {trackNavRightFeatureOpened} from '../../../services/analytics/productEvents';
import {ActivationMethods} from '../../../services/analytics/types';
import {
  useIsAdminModeActiveAndIsNotLocalEnv,
  viewingAs,
} from '../../../util/admin';
import {useNavContext, useNavUpdaterContext} from '../../NavContextProvider';
import {useSearchNavAnalytics} from '../useSearchNavAnalytics';
import {AccountSelectorContext} from './AccountSelectorContextProvider';
import {Button, Wrapper} from './NavResources';

const NavSearchButton: FC = () => {
  const {searchActive} = useNavContext();
  const {toggleSearch} = useNavUpdaterContext();
  const {trackSearchNavOnScreen, trackAppLauncherOnScreen} =
    useSearchNavAnalytics();
  const {selectedAccount} = useContext(AccountSelectorContext);
  const isAdminMode =
    useIsAdminModeActiveAndIsNotLocalEnv() || viewingAs() !== '';
  const {
    state: tooltipOpen,
    setTrue: openTooltip,
    setFalse: closeTooltip,
  } = useBooleanState(false);

  const onClick = () => {
    if (!searchActive) {
      trackSearchNavOnScreen(ActivationMethods.MouseClick);
      trackAppLauncherOnScreen(ActivationMethods.MouseClick);
      trackNavRightFeatureOpened({
        feature: 'search',
        selected_account: selectedAccount,
        is_admin_mode: isAdminMode,
      });
    }
    toggleSearch();
  };

  return (
    <Wrapper onClick={onClick} $marginRight={7}>
      <TooltipDeprecated
        position="bottom center"
        open={tooltipOpen && !searchActive}
        onOpen={openTooltip}
        onClose={closeTooltip}
        trigger={
          <Button
            $active={searchActive}
            $showAdminBanner={isAdminMode}
            aria-label="Global search">
            <Icon />
          </Button>
        }>
        Global search <Shortcut keys={[isMac ? `Cmd` : `Ctrl`, `K`]} />
      </TooltipDeprecated>
    </Wrapper>
  );
};

export default NavSearchButton;

const Icon = styled(IconSearch)`
  display: block;
  width: 24px;
  height: 24px;
`;

const Shortcut = styled(KeyboardShortcut)`
  margin-left: 10px;
`;
